import type { DirectoryUsersResponse } from '@ai-meeting/shared'
import { apiClient } from './api'

/**
 * Fetches the Entra tenant's colleagues, used to suggest people wherever the app
 * has to name one — the sign-in allowlist and the action-item assignee.
 *
 * Never throws. The directory is a convenience over fields that already work
 * without it, so a tenant that has not granted the Graph permission, a guest
 * account the server answers with an empty list, or an outage all leave the
 * caller typing the value as before instead of seeing an error it cannot act on.
 */
export async function fetchDirectoryUsers(): Promise<DirectoryUsersResponse> {
  try {
    const { data } = await apiClient.get<DirectoryUsersResponse>('/api/directory/users')
    return data
  } catch {
    return { users: [] }
  }
}
